import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useUploadDocument = () => {
  const { call, isLoading, isFailed } = useApiPrivateRequest<string>(
    (response) => response.id,
  );

  const uploadDocument = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return await call("/documents", "POST", undefined, formData);
  };

  return { uploadDocument, isLoading, isFailed };
};
